import { gql } from '@apollo/client';

export const DELETE_GROUP = gql`
  mutation deleteSearchFiltersGroup($id: String!) {
    deleteSearchFiltersGroup(ID: $id)
  }
`;
